import {
  BrowserRouter as Router,
  Navigate,
  Route,
  Routes,
} from "react-router-dom";
import ComplianceProtectedRoute from "./components/ComplianceProtectedRoute";
import ComplianceLayout from "./components/compliance/ComplianceLayout";
import ComplianceDashboard from "./components/compliance/ComplianceDashboard";
import DocumentWorkspace from "./components/compliance/DocumentWorkspace";
import RiskCenter from "./components/compliance/RiskCenter";
import AuditCenter from "./components/compliance/AuditCenter";
import WorkflowCenter from "./components/compliance/WorkflowCenter";
import WorkflowManager from "./components/compliance/WorkflowManager";
import UserManagement from "./components/compliance/UserManagement";
import NotificationsPage from "./components/compliance/NotificationsPage";
import CopilotPanel from "./components/compliance/CopilotPanel";
import ShipmentCaseWorkspace from "./components/compliance/ShipmentCaseWorkspace";
import ControlTower from "./components/compliance/ControlTower";
import V2IntelligencePanel from "./components/compliance/V2IntelligencePanel";
import OperatorAnalyticsDashboard from "./components/compliance/OperatorAnalyticsDashboard";
import WebhookIntegrationConsole from "./components/compliance/WebhookIntegrationConsole";
import { ComplianceAuthProvider } from "./context/ComplianceAuthContext";
import { LinkLightAdminAuthProvider } from "./context/LinkLightAdminAuthContext";
import ComplianceLoginPage from "./pages/ComplianceLoginPage";
import LinkLightAdminPage from "./pages/LinkLightAdminPage";
import PilotOfferPage from "./pages/PilotOfferPage";
import MarketingLandingPage from "./pages/MarketingLandingPage";

export function AppRoutes() {
  return (
    <Routes>
      <Route path="/" element={<ComplianceLoginPage />} />
      <Route path="/pilot" element={<PilotOfferPage />} />
      <Route path="/compliance-readiness-pilot" element={<PilotOfferPage />} />
      <Route
        path="/logistics-compliance-automation"
        element={<MarketingLandingPage page="logistics" />}
      />
      <Route
        path="/manufacturing-logistics-compliance"
        element={<MarketingLandingPage page="manufacturing" />}
      />
      <Route
        path="/partners"
        element={<MarketingLandingPage page="partners" />}
      />
      <Route
        path="/investors"
        element={<MarketingLandingPage page="investors" />}
      />
      <Route
        path="/Compliance/logistics/login"
        element={<ComplianceLoginPage />}
      />
      <Route path="/login" element={<Navigate to="/" replace />} />
      <Route path="/signup" element={<Navigate to="/" replace />} />

      <Route
        path="/compliance/login"
        element={<Navigate to="/Compliance/logistics/login" replace />}
      />
      <Route
        path="/compliance/*"
        element={<Navigate to="/Compliance/logistics/login" replace />}
      />

      <Route
        path="/admin"
        element={<LinkLightAdminPage />}
      />

      <Route
        path="/Compliance/logistics"
        element={
          <ComplianceProtectedRoute>
            <ComplianceLayout />
          </ComplianceProtectedRoute>
        }
      >
        <Route index element={<Navigate to="dashboard" replace />} />
        <Route path="dashboard" element={<ComplianceDashboard />} />
        <Route path="control-tower" element={<ControlTower />} />
        <Route path="analytics" element={<OperatorAnalyticsDashboard />} />
        <Route path="v2-intelligence" element={<V2IntelligencePanel />} />
        <Route path="documents" element={<DocumentWorkspace />} />
        <Route path="cases" element={<ShipmentCaseWorkspace />} />
        <Route path="workflows" element={<WorkflowCenter />} />
        <Route path="workflows/manage" element={<WorkflowManager />} />
        <Route path="integrations/webhooks" element={<WebhookIntegrationConsole />} />
        <Route path="users" element={<UserManagement />} />
        <Route path="notifications" element={<NotificationsPage />} />
        <Route path="risks" element={<RiskCenter />} />
        <Route path="audit" element={<AuditCenter />} />
        <Route path="copilot" element={<CopilotPanel />} />
      </Route>

      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

function App() {
  return (
    <ComplianceAuthProvider>
      <LinkLightAdminAuthProvider>
        <Router>
          <AppRoutes />
        </Router>
      </LinkLightAdminAuthProvider>
    </ComplianceAuthProvider>
  );
}

export default App;
